import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OverlayButton from '../BuildingBlocks/OverlayButton/OverlayButton';
import Text from '../BuildingBlocks/Text/Text';
import {
  BannerThreeContainer,
  ImageContainer,
  StyledHeadingFourth,
  ModalImageContainer,
  ModalHeadingContainer,
  ModalParaContainer,
  PreloadedImage,
  ButtonContainer,
  NavButton,
  StyledDescriptionText,
  StyledGridContainer
} from './BannerThree.styles';
import Grid from '../Utility/Grid';
import Adaptive from '../Adaptive';
import Modal from '../BaseModal/Modal';
import SVGIcon from '../SVGIcon';
import { colors } from '../css';

class BannerThree extends Component {
  static propTypes = {
    /** Image src, title and description */
    images: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        src: PropTypes.string.isRequired,
        title: PropTypes.string,
        desc: PropTypes.string
      })
    ).isRequired,
    /** Text that displays on the button that opens the gallery */
    photoButtonText: PropTypes.string,
    /** Function passed for onClick of view photos button */
    onClickPhotoButton: PropTypes.func,
    /** Text that displays on the directions button */
    directionButtonText: PropTypes.string,
    /** Function passed for onClick of get directions button */
    getDirections: PropTypes.func,
    /** Bool value that shows/hides get directions button */
    directionsAvailable: PropTypes.bool
  };

  static defaultProps = {
    photoButtonText: 'View Photos',
    onClickPhotoButton: () => {},
    directionButtonText: 'Get Directions',
    getDirections: () => {},
    directionsAvailable: false
  };

  constructor(props) {
    super(props);

    this.state = {
      galleryOpen: false,
      galleryIndex: 0,
      showNext: true,
      showPrev: false
    };

    this.renderImages = this.renderImages.bind(this);
    this.preloadedImage = this.preloadedImage.bind(this);

    this.openGallery = this.openGallery.bind(this);
    this.closeGallery = this.closeGallery.bind(this);

    this.prevSlide = this.prevSlide.bind(this);
    this.nextSlide = this.nextSlide.bind(this);

    this.renderTally = this.renderTally.bind(this);
  }

  openGallery() {
    const { onClickPhotoButton } = this.props;

    this.setState({ galleryOpen: true });
    onClickPhotoButton();
  }

  closeGallery() {
    this.setState({ galleryOpen: false });
  }

  prevSlide() {
    const { galleryIndex, showNext } = this.state;

    if (galleryIndex > 0) {
      this.setState({ galleryIndex: galleryIndex - 1 });
      if (showNext === false) {
        this.setState({ showNext: true });
      }
    }
    if (galleryIndex - 1 === 0) {
      this.setState({ showPrev: false });
    }
  }

  nextSlide() {
    const { galleryIndex, showPrev } = this.state;
    const { images } = this.props;

    if (galleryIndex + 1 < images.length) {
      this.setState({ galleryIndex: galleryIndex + 1 });
      if (showPrev === false) {
        this.setState({ showPrev: true });
      }
    }

    if (galleryIndex + 2 === images.length) {
      this.setState({ showNext: false });
    }
  }

  preloadedImage() {
    const { galleryIndex } = this.state;
    const { images } = this.props;

    let next = null;

    if (galleryIndex + 1 < images.length) {
      next = images[galleryIndex + 1];
    }

    return next;
  }

  renderImages() {
    const { images } = this.props;

    let pfaArray = images;

    if (images.length > 3) {
      pfaArray = images.slice(0, 3);
    }

    const imageList = pfaArray.map(image => (
      <ImageContainer className="pfa-image" length={pfaArray.length} key={image.id} backgroundImage={image.src}>
        {/** Empty div with bg image */}{' '}
      </ImageContainer>
    ));

    let imageLayout;
    const imageLength = imageList.length;

    if (imageLength === 1) {
      imageLayout = imageList;
    } else if (imageLength === 2) {
      imageLayout = <Adaptive sm={imageList[0]} lg={imageList} />;
    } else {
      imageLayout = <Adaptive sm={imageList[0]} lg={imageList.slice(0, 2)} xl={imageList} />;
    }
    return imageLayout;
  }

  renderTally() {
    const { galleryIndex } = this.state;
    const { images } = this.props;

    return `${galleryIndex + 1}/${images.length}`;
  }

  render() {
    const pfaImages = this.renderImages();
    const { images, photoButtonText, directionButtonText, getDirections, directionsAvailable } = this.props;
    const { galleryOpen, galleryIndex, showNext, showPrev } = this.state;

    return (
      <BannerThreeContainer nogutter>
        {pfaImages}

        <ButtonContainer>
          {directionsAvailable && (
            <OverlayButton className="directions" icon="directions" onClick={getDirections}>
              {directionButtonText}
            </OverlayButton>
          )}

          <OverlayButton className="gallery" onClick={this.openGallery}>
            {photoButtonText}
          </OverlayButton>
        </ButtonContainer>

        <Modal
          handleClose={this.closeGallery}
          open={galleryOpen}
          width="100%"
          height="100vh"
          bgColor={colors.colorBlackRgba(0.6)}
          closeButton={<SVGIcon selectedIcon="closeModal" iconColor={colors.colorWhite} />}
        >
          <Grid.Container>
            <ModalHeadingContainer>
              {images[galleryIndex].title && (
                <StyledHeadingFourth color="secondary" tagName="h2">
                  {images[galleryIndex].title}
                </StyledHeadingFourth>
              )}
            </ModalHeadingContainer>
          </Grid.Container>

          <StyledGridContainer>
            <ModalImageContainer>
              <img src={images[galleryIndex].src} alt="" />
              {this.preloadedImage() && <PreloadedImage src={this.preloadedImage().src} alt="" />}
            </ModalImageContainer>
          </StyledGridContainer>

          <Grid.Container>
            <ModalParaContainer>
              <StyledDescriptionText color="secondary">
                <Text.CopyParagraph tagName="span" color="secondary" weight="bold">
                  {this.renderTally()}
                </Text.CopyParagraph>
                {images[galleryIndex].desc && `: ${images[galleryIndex].desc}`}
              </StyledDescriptionText>
            </ModalParaContainer>
          </Grid.Container>

          {images.length >= 2 && (
            <Grid.ScreenClassRender
              render={screenClass => (
                <div>
                  {showPrev && (
                    <NavButton side="prev" className="previous" onClick={this.prevSlide}>
                      <SVGIcon
                        selectedIcon="arrow"
                        iconColor={colors.colorWhite}
                        width={['xs', 'sm'].includes(screenClass) ? '15px' : '30px'}
                      />
                    </NavButton>
                  )}
                  {showNext && (
                    <NavButton side="next" className="next" onClick={this.nextSlide}>
                      <SVGIcon
                        selectedIcon="arrow"
                        iconColor={colors.colorWhite}
                        width={['xs', 'sm'].includes(screenClass) ? '15px' : '30px'}
                      />
                    </NavButton>
                  )}
                </div>
              )}
            />
          )}
        </Modal>
      </BannerThreeContainer>
    );
  }
}

export default BannerThree;
